import { ApiSchema } from "@api-types";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { hasAnyPolicy$ } from "helpers/hasPolicy";
import React, { useEffect } from "react";
import { ScrollRestoration, useLocation } from "react-router-dom";
import { useSubscription } from "rsm/useSubscription";
import { of } from "rxjs";
import { getFFService } from "services/ff.service";
import { getRoutingService } from "services/routing.service";

interface ModuleRouteProps {
  El: React.LazyExoticComponent<React.FC<{}>>;
  moduleName: string;
  inPolicies?: ApiSchema.Policy[];
  ff?: ApiSchema.FF;
}

const ModuleRoute: React.FC<ModuleRouteProps> = ({ El, moduleName, inPolicies, ff }) => {
  const location = useLocation();

  useEffect(() => getRoutingService().updateModuleNavigation(moduleName, location), [moduleName, location]);

  useSubscription(
    inPolicies?.length ? hasAnyPolicy$(inPolicies) : of(true),
    (hasPolicy) => {
      if (inPolicies?.length && !hasPolicy) {
        window.location.href = "/";
      }
    },
    [inPolicies?.length, inPolicies?.join(",")],
  );

  useSubscription(
    ff ? getFFService().featureEnabled$(ff) : of(true),
    (hasFeature) => {
      if (!hasFeature) {
        window.location.href = "/";
      }
    },
    [ff],
  );

  return (
    <React.Suspense fallback={<LoadingPage />}>
      <El />
      <ScrollRestoration
        getKey={(location) => {
          // Only use the pathname to identify the scroll position, ignoring query params
          return location.pathname;
        }}
      />
    </React.Suspense>
  );
};

export default ModuleRoute;
